import { render, staticRenderFns } from "./TestimonialCarousel.vue?vue&type=template&id=09607583"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js"
import style0 from "./TestimonialCarousel.vue?vue&type=style&index=0&id=09607583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports